import { render, staticRenderFns } from "./popupProdottoSuggerito.vue?vue&type=template&id=71c765e6&"
import script from "./popupProdottoSuggerito.vue.ts?vue&type=script&lang=ts&"
export * from "./popupProdottoSuggerito.vue.ts?vue&type=script&lang=ts&"
import style0 from "./popupProdottoSuggerito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports